
const config = function () {
  return {
    bankCardList: [
      {
        el: 'input',
        itemConfig: {
          label: '收款账户名称',
          prop: 'payeeMerchantName',
        },
        elConfig: {
          placeholder: '请输入',
          maxlength: '100',
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '收款账户类型',
          prop: 'payeeAccountType',
        },
        elConfig: {
          placeholder: '请选择',
          options: {
            label: 'accountTypeName',
            value: 'accountTypeCode',
            list: [],
          },
          events: {
            change: (type) => {
              this.bindBankCardShowItem(type)
            },
          },
        },
      },
      {
        el: 'text',
        itemConfig: {
          label: '收款人支行名称',
          prop: 'payeeBranchName',
        },
        elConfig: {
          placeholder: '请输入',
          maxlength: '100',
        },
        isShow: false,
      },
      {
        el: 'input',
        itemConfig: {
          label: '收款人卡号',
          prop: 'bankCardNo',
        },
        elConfig: {
          placeholder: '请输入',
          maxlength: '50',
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '收款人联行号',
          prop: 'payeeContactLine',
        },
        elConfig: {
          placeholder: '请输入',
          maxlength: '64',
        },
        directives: [{ name: 'number', arg: 'integer', modifiers: { noTrim: true }, value: 30 }],
        isShow: false,
      },
    ],
    bankCardRules: {
      payeeMerchantName: [
        {
          required: true,
          message: '请输入收款账户名称',
          trigger: 'blur',
        },
      ],
      payeeAccountType: [
        {
          required: true,
          message: '请选择账户类型',
          trigger: 'blur',
        },
      ],
      bankCardNo: [
        {
          required: true,
          message: '请输入收款人卡号',
          trigger: 'blur',
        },
      ],
      payeeContactLine: [
        {
          required: true,
          message: '请输入收款人联行号',
          trigger: 'blur',
        },
      ],
      payeeBranchName: [
        {
          required: true,
          message: '请输入收款人支行名称',
          trigger: 'blur',
        },
      ],
    },
  }
}

export default config
